import { NgModule } from '@angular/core';
import { RenderBlocksModule } from 'render/render-blocks/render-blocks.module';
import { RenderSharedModule } from 'render/render-shared/render-shared.module';
import { SharedModule } from 'shared/shared.module';

import { SliceFlexCloseComponent } from './slice-flex-close/slice-flex-close.component';
import { SliceFlexRenderComponent } from './slice-flex-render.component';


export const sliceFlexRenderModuleEntryComponents = [
  SliceFlexRenderComponent,
  SliceFlexCloseComponent
];

@NgModule({
  imports: [
    SharedModule,
    RenderSharedModule,
    RenderBlocksModule
  ],
  exports: [
    sliceFlexRenderModuleEntryComponents
  ],
  declarations: sliceFlexRenderModuleEntryComponents
})
export class SliceFlexRenderModule {}

export default sliceFlexRenderModuleEntryComponents;
